// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1N9xr","box":"WorkspacesBox_box__3zn--","node":"WorkspacesBox_node__D0pB6"};